import {
  EAuditResultType,
} from '@/types/audit-result.ts';
import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const sectionResult: Record<TComponentValue<'AuditResultType'>, string> = {
  [EAuditResultType.PASSED]: 'W paśmie',
  [EAuditResultType.INCONCLUSIVE]: 'Nierozstrzygnięte',
  [EAuditResultType.FAILED]: 'Poza pasmem',
};

export default {
  timeIn: 'Czas w środku',
  timeOut: 'Czas na przerwę',
  valueAtStart: 'Wartość na początku',
  valueRange: 'Zakres wartości',
  mainTemp: 'Główna temperatura',
  medianValue: 'Wartość środkowa',
  timeInBand: 'Czas w zespole',
  sectionResult,
};
